import InviteeScreen from './invitee-screen.component';

export default InviteeScreen;
